import React, { useState } from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';

export const PageLength = ({
    handlePageLength, pageLength,
    total
}) => {

    const [dropdownOpen, setDropdownOpen] = useState(false);
    const toggle = () => setDropdownOpen((prevState) => !prevState);

    return (
        <div className="result-foot d-flex align-items-center gap-1">
            <style>
                {`
                .filter-dropdown-menu .filter-dropdown-item{
                    color: #6c889c !important;
                    font-weight: 500;
                    font-size: 16px;
                }
                .filter-dropdown-menu .filter-dropdown-item:hover {
                    background-color: #6f8cff62 !important;
                    color: #6c889c !important;
                }
                `}
            </style>
            <span> Showing </span>
            <Dropdown isOpen={dropdownOpen} toggle={toggle} direction="down">
                <DropdownToggle
                    tag="span"
                    className="filter-action-count-dropdown dropdown-toggle noselect d-flex align-items-center justify-content-end dropdown-subscribers"
                    style={{ cursor: 'pointer' }}
                    data-toggle="dropdown"
                    aria-expanded={dropdownOpen}
                >
                    {pageLength}
                </DropdownToggle>
                <DropdownMenu className="filter-dropdown-menu">
                    {[10, 25, 50, 100].map((value) => (
                        <DropdownItem
                            key={value}
                            className="filter-dropdown-item"
                            onClick={() => handlePageLength(value)}
                        >
                            {value}
                        </DropdownItem>
                    ))}
                </DropdownMenu>
            </Dropdown>
            <span>of {total} records</span>
        </div>
    )
}
